"use client";

import * as React from "react";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PolicyOverview() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <section data-section-id="158289" id="policy-overview" className="bg-background text-foreground radiating-pattern pt-32 pb-16 px-4 md:px-8 overflow-hidden">
      <div className="container mx-auto flex flex-col items-center text-center">
        <div ref={ref} className={`flex flex-col items-center transition-all duration-[600ms] ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <h1 className="font-sans font-extrabold text-5xl md:text-6xl text-foreground mb-6 tracking-tighter uppercase drop-shadow-[0_1px_2px_rgba(255,255,255,0.2)]">
            Privacy Policy
          </h1>
          
          <Separator className="w-20 h-[1px] bg-primary mb-8 shadow-[0_0_8px_rgba(230,184,0,0.3)]" decorative />
          
          <p className="font-sans font-medium text-lg leading-relaxed max-w-[800px] text-foreground/90">
            This Privacy Policy describes the way we collect, manage, and protect 
            your personal information. It is our fundamental commitment to ensure 
            your privacy, implementing the highest security standards and strictly 
            adhering to all applicable regulations, so you can engage with our 
            services with complete peace of mind.
          </p>
        </div>
      </div>
    </section>;
}